import React from 'react'
import { Box, Chip, Typography } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
const useParamRowStyles = makeStyles((t: Theme) => ({
	row: {
		display: 'flex',
		alignItems: 'center',
		gap: 14,
		padding: '8px 16px',
		[t.breakpoints.down('xs')]: {
			gap: 8,
		},
	},
	labelBox: {
		minWidth: 0,
		flexShrink: 0,
		width: 210,
		[t.breakpoints.down('xs')]: {
			width: 'auto',
			flex: '1 1 0',
			minWidth: 0,
		},
	},
	labelRow: {
		display: 'flex',
		alignItems: 'flex-start',
		width: 'fit-content',
		maxWidth: '100%',
		flexWrap: 'wrap',
		marginBottom: 6,
		gap: 4,
	},
	spacer: {
		flex: 1,
		[t.breakpoints.down('xs')]: {
			display: 'none',
		},
	},
	control: {
		flexShrink: 0,
		[t.breakpoints.down('xs')]: {
			marginLeft: 'auto',
			flex: '0 0 120px',
			width: 120,
		},
	},
	label: {
		fontWeight: 600,
		flex: '0 0 auto',
		margin: 0,
		lineHeight: 1.25,
		[t.breakpoints.down('xs')]: {
			fontSize: 12,
		},
	},
	badge: {
		flex: '0 0 auto',
		height: 20,
		marginTop: 1,
		'& .MuiChip-label': {
			paddingLeft: 6,
			paddingRight: 6,
			fontSize: 10,
			lineHeight: 1.2,
		},
	},
	description: {
		lineHeight: 1.4,
		display: 'block',
		marginTop: 0,
		color: '#9e9e9e',
		[t.breakpoints.down('xs')]: {
			fontSize: 10.5,
		},
	},
	descriptionError: {
		color: '#d32f2f',
	},
}))

export interface ParamRowProps {
	label: string
	description: string
	badge?: string | null
	error?: boolean
	isLast?: boolean
	children: React.ReactNode
}

export function ParamRow({
	label,
	description,
	badge = null,
	error = false,
	isLast = false,
	children,
}: ParamRowProps) {
	const classes = useParamRowStyles()
	return (
		<Box
			className={classes.row}
			style={{
				borderBottom: isLast ? 'none' : '1px solid rgba(0,0,0,0.06)',
			}}
		>
			<Box className={classes.labelBox}>
				<Box className={classes.labelRow}>
					<Typography
						variant="body2"
						component="span"
						className={classes.label}
					>
						{label}
					</Typography>
					{badge && (
						<Chip label={badge} size="small" className={classes.badge} />
					)}
				</Box>
				<Typography
					variant="caption"
					className={`${classes.description}${
						error ? ` ${classes.descriptionError}` : ''
					}`}
				>
					{description}
				</Typography>
			</Box>
			<Box className={classes.spacer} />
			<Box className={classes.control}>{children}</Box>
		</Box>
	)
}
